// @ts-nocheck
(function () {
  "use strict";

  const KEY = "breadcrumb_path";
  const PAGE_KEY = "breadcrumb_page_path";
  const INJECTED = "data-injected";
  const MENU_SELECTOR =
    ".header__nav-link[href], .header__nav-dropdown-link[href], .menu-list__link[href], .overflow-dropdown-link[href]";

  const DRILL_BIT_FINDER_PARENT = "/pages/drill-bit-finder";
  const DRILL_BIT_FINDER_PARENT_TITLE = "Drill Bit Finder";
  const LEVEL_1_PAGES = ["/pages/cutting", "/pages/drilling", "/pages/grinding"];
  const MENU_PRODUCT_FLAG = "breadcrumb_menu_product";

  // Clear the menu-product flag on any non-product page so that future
  // collection → product navigations still inject collection breadcrumbs.
  if (!location.pathname.includes("/products/")) {
    sessionStorage.removeItem(MENU_PRODUCT_FLAG);
  }

  // Cached DOM references — refreshed via resolveElements()
  let cachedNav = null;
  let cachedList = null;

  function resolveElements() {
    cachedNav = document.querySelector(".breadcrumbs");
    cachedList = document.querySelector(".breadcrumbs__list");
  }

  // When a user clicks a menu link that points directly to a product,
  // flag it so breadcrumbs stay as Home > Product (no collection injection).
  document.addEventListener("click", (event) => {
    const menuLink = event.target.closest(MENU_SELECTOR);
    if (!menuLink) return;

    const href = menuLink.getAttribute("href");
    if (href && href.includes("/products/")) {
      sessionStorage.setItem(MENU_PRODUCT_FLAG, "true");
    }
  });

  function isDrillBitFinderPage(path) {
    if (path === DRILL_BIT_FINDER_PARENT) return true;
    return LEVEL_1_PAGES.some((page) => path === page || path.startsWith(page + "-"));
  }

  function getLevel1Parent(path) {
    for (const level1 of LEVEL_1_PAGES) {
      if (path.startsWith(level1 + "-")) {
        return level1;
      }
    }
    return null;
  }

  function getLevel1Title(path) {
    const pageTitleMap = {
      "/pages/cutting": "Cutting",
      "/pages/drilling": "Drilling",
      "/pages/grinding": "Grinding",
    };

    if (pageTitleMap[path]) {
      return pageTitleMap[path];
    }

    const pathParts = path.split("/").pop();
    if (pathParts) {
      return pathParts.charAt(0).toUpperCase() + pathParts.slice(1);
    }

    return null;
  }

  function isFromCollection() {
    const ref = document.referrer;
    if (!ref) return false;
    try {
      const refUrl = new URL(ref);
      return (
        refUrl.origin === location.origin &&
        refUrl.pathname.includes("/collections/") &&
        !refUrl.pathname.includes("/products/")
      );
    } catch {
      return false;
    }
  }

  function isProductInMenu(path) {
    return [...document.querySelectorAll(MENU_SELECTOR)].some((link) => {
      const href = link.getAttribute("href")?.split("?")[0];
      return href && path.includes(href);
    });
  }

  function getHistory() {
    try {
      let h = JSON.parse(sessionStorage.getItem(KEY) || "[]");
      if (!Array.isArray(h)) return [];

      let referrerCollectionHandle = null;
      try {
        const ref = document.referrer;
        if (ref) {
          const refUrl = new URL(ref);
          if (refUrl.origin === location.origin && refUrl.pathname.includes("/collections/")) {
            const refMatch = refUrl.pathname.match(/\/collections\/([^\/\?#]+)/);
            if (refMatch) {
              referrerCollectionHandle = refMatch[1];
            }
          }
        }
      } catch (e) {}

      if (h.length === 2) {
        const [first, second] = h;
        if (!second.parentHandle) {
          if (referrerCollectionHandle === second.handle) {
            h = [second];
          } else if (referrerCollectionHandle === first.handle) {
            h = [first];
          } else {
            h = [second]; // fallback to most recent
          }
        } else if (second.parentHandle === first.handle) {
          if (referrerCollectionHandle === first.handle) {
            h = [first];
          }
        } else {
          h = [second];
        }
      }

      if (referrerCollectionHandle) {
        h = h.filter((item) => {
          if (item.handle === referrerCollectionHandle) {
            return true;
          }
          if (item.parentHandle === referrerCollectionHandle) {
            return false;
          }
          return true;
        });
      }

      if (h.length === 1 && referrerCollectionHandle) {
        const singleItem = h[0];
        if (singleItem.handle === referrerCollectionHandle) {
        } else if (singleItem.parentHandle === referrerCollectionHandle) {
          h = [];
        }
      }

      const seen = new Set();
      const result = h.filter((i) => !seen.has(i.handle) && seen.add(i.handle));

      if (result.length === 0 && h.length === 1) {
        const singleItem = h[0];
        if (!singleItem.parentHandle) {
          return [singleItem];
        }
      }

      return result;
    } catch {
      return [];
    }
  }

  function update(preserveHistory = false) {
    if (!location.pathname.includes("/products/")) return;

    const productItem = cachedList?.querySelector("[data-breadcrumb-product]");
    if (!cachedList || !productItem) return;

    cachedList.querySelectorAll(`[${INJECTED}]`).forEach((el) => el.remove());

    const h1 = document.querySelector('h1.product__title, h1[class*="product"], .product-info h1');
    const titleEl = productItem.querySelector(".breadcrumbs__current");
    if (h1 && titleEl) titleEl.textContent = h1.textContent?.trim() || "";

    if (isProductInMenu(location.pathname)) {
      return;
    }

    // If the user reached this product by clicking a direct product link in the
    // header nav or center menu, keep breadcrumbs as Home > Product.
    // The flag persists across variant changes (pushState) and is only cleared
    // when the user navigates to a non-product page.
    if (sessionStorage.getItem(MENU_PRODUCT_FLAG) === "true") {
      return;
    }

    // Only inject collection breadcrumbs if the user arrived from a collection page.
    // This covers both initial page load and variant changes (document.referrer
    // persists across pushState calls from the category filter).
    if (!isFromCollection()) {
      return;
    }

    const history = getHistory();

    if (!history.length) {
      return;
    }

    const frag = document.createDocumentFragment();
    history.forEach(({ url, title, handle }) => {
      let displayTitle = title;
      if (handle && title && title.toLowerCase().replace(/\s+/g, "-") === handle.toLowerCase()) {
        displayTitle = title
          .split("-")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");
      }

      const li = document.createElement("li");
      li.className = "breadcrumbs__item";
      li.setAttribute(INJECTED, "");
      li.innerHTML = `<a href="${url}" class="breadcrumbs__link">${displayTitle}</a>`;
      frag.appendChild(li);
    });
    cachedList.insertBefore(frag, productItem);
  }

  function updatePageBreadcrumbs() {
    const path = location.pathname;

    if (!isDrillBitFinderPage(path)) {
      return;
    }

    if (!cachedList) {
      return;
    }

    const currentTitleEl = cachedList.querySelector(".breadcrumbs__current");
    const currentItem =
      currentTitleEl?.closest(".breadcrumbs__item") || cachedList.querySelector(".breadcrumbs__item:last-child");
    if (!currentItem) {
      return;
    }

    cachedList.querySelectorAll(`[${INJECTED}]`).forEach((el) => el.remove());

    const h1 = document.querySelector("h1");
    if (h1 && currentTitleEl) {
      currentTitleEl.textContent = h1.textContent?.trim() || currentTitleEl.textContent;
    }

    const frag = document.createDocumentFragment();
    const breadcrumbsToAdd = [];

    const level1Parent = getLevel1Parent(path);

    if (level1Parent) {
      const level1Title = getLevel1Title(level1Parent);
      if (level1Title) {
        breadcrumbsToAdd.push({
          url: level1Parent,
          title: level1Title,
        });
      }
    }

    breadcrumbsToAdd.forEach(({ url, title }) => {
      const li = document.createElement("li");
      li.className = "breadcrumbs__item";
      li.setAttribute(INJECTED, "");
      li.innerHTML = `<a href="${url}" class="breadcrumbs__link">${title}</a>`;
      frag.appendChild(li);
    });

    if (frag.children.length > 0) {
      cachedList.insertBefore(frag, currentItem);
    }
  }

  function capitalizeWordsInBreadcrumbs() {
    try {
      if (!cachedNav) return;

      const wordsToCapitalize = cachedNav.getAttribute("data-capitalize-words");
      if (!wordsToCapitalize || !wordsToCapitalize.trim()) return;

      const words = wordsToCapitalize
        .split(",")
        .map((w) => w.trim())
        .filter((w) => w.length > 0);

      if (words.length === 0) return;

      // Create a regex pattern for case-insensitive word boundary matching
      // Escape special regex characters in each word
      const escapedWords = words.map((word) => word.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));
      const pattern = new RegExp(`\\b(${escapedWords.join("|")})\\b`, "gi");

      function processElement(element) {
        const originalText = element.textContent || "";
        if (!originalText) return;

        const updatedText = originalText.replace(pattern, (match) => {
          return match.toUpperCase();
        });

        if (updatedText !== originalText) {
          element.textContent = updatedText;
        }
      }

      const currentItems = document.querySelectorAll(".breadcrumbs__current");
      currentItems.forEach(processElement);

      const linkItems = document.querySelectorAll(".breadcrumbs__link");
      linkItems.forEach(processElement);
    } catch (e) {
      console.warn("Breadcrumb word capitalization error:", e);
    }
  }

  function updateAllBreadcrumbs(preserveHistory = false) {
    // Refresh cached DOM references (handles DOM patches from variant changes)
    resolveElements();
    try {
      update(preserveHistory);
      updatePageBreadcrumbs();
    } finally {
      if (cachedNav) {
        cachedNav.setAttribute("data-enhanced", "true");
      }
      capitalizeWordsInBreadcrumbs();
    }
  }

  window.updateBreadcrumbsForProduct = updateAllBreadcrumbs;
  window.updateAllBreadcrumbs = updateAllBreadcrumbs;

  function runUpdaters() {
    updateAllBreadcrumbs();
    // Single delayed fallback for async-rendered content; MutationObserver handles later changes
    setTimeout(() => capitalizeWordsInBreadcrumbs(), 300);
  }

  function setupCapitalizationObserver() {
    if (!cachedNav) return;

    let timeoutId = null;
    const observer = new MutationObserver(() => {
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        capitalizeWordsInBreadcrumbs();
      }, 100);
    });

    observer.observe(cachedNav, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", () => {
        runUpdaters();
        setupCapitalizationObserver();
      })
    : (() => {
        runUpdaters();
        setupCapitalizationObserver();
      })();
})();
